<template>
  <div class="decontamination">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>